import classNames from 'classnames';

import { iconDefaults } from '.';
import { IconProps as Props } from '../types/hubInterfaces';

function ArrowIcon(props: Props) {
  const { width, height, className } = { ...iconDefaults, ...props };
  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4286 6.47124L19.6573 11.6527C20.263 12.1576 21.1644 12.0749 21.6687 11.4702C22.1744 10.864 22.0916 9.96551 21.4858 9.46205L12.9144 2.33089C12.8472 2.27526 12.7686 2.24674 12.6944 2.20538C12.6344 2.17115 12.5829 2.12979 12.5172 2.10412C12.3529 2.03993 12.1801 2.00143 12.0058 2.00143C12.0044 2.00143 12.0015 2 12.0001 2C11.9986 2 11.9958 2.00143 11.9944 2.00143C11.8201 2.00143 11.6472 2.03993 11.4829 2.10412C11.4172 2.12979 11.3658 2.17115 11.3058 2.20538C11.2315 2.24674 11.1529 2.27526 11.0858 2.33089L2.51429 9.46205C2.17571 9.74445 2 10.1495 2 10.5574C2 10.8797 2.10857 11.2035 2.33143 11.4702C2.83572 12.0749 3.73715 12.1576 4.34287 11.6527L10.5715 6.47124L10.5715 20.5738C10.5715 21.361 11.2115 22 12.0001 22C12.7886 22 13.4286 21.361 13.4286 20.5738L13.4286 6.47124Z"
      />
    </svg>
  );
}

export { ArrowIcon };
